/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { get, ref, query, orderByChild, equalTo } from "firebase/database";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Paper,
  Card,
  CardContent,
} from "@mui/material";
import { auth, database } from "../../../firebase";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../Common/Pagination";
const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [company, setCompanyId] = useState("");
  const [page, setPage] = useState(1);

  const usersPerPage = 10;

  useEffect(() => {
    fetchUserInfo();
    fetchUsers(company, page);
    setLoading(true);
  }, [company, page]);

  const fetchUserInfo = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      const userRef = ref(database, "users/" + currentUser.uid);
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userData = snapshot.val();
        setCompanyId(userData.companyId);
      }
    }
  };

  const fetchUsers = async (companyId, page) => {
    setLoading(true);
    try {
      console.log(companyId);
      const userRef = query(
        ref(database, "users"),
        orderByChild("companyId"),
        equalTo(companyId)
      );
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userlist = snapshot.val();
        const usersData = [];
        for (const key in userlist) {
          // Iterate over object keys
          const user = userlist[key];
          if (user.isActive === true) {
            const profileRef = ref(database, "profiles/" + user.uid);
            const profileSnapshot = await get(profileRef);
            if (profileSnapshot.exists()) {
              const userProfile = profileSnapshot.val();
              const middleNameSegment = userProfile.middleName || "";
              user.name =
                `${userProfile.firstName} ${
                  middleNameSegment ? middleNameSegment + " " : ""
                }${userProfile.lastName}` || "Not Active";
              user.email = userProfile.contactEmail;
              usersData.push(user);
            }
          } else {
            user.name = "No Active";
          }
        }

        const startIndex = (page - 1) * usersPerPage;
        const paginatedUsers = usersData.slice(
          startIndex,
          startIndex + usersPerPage
        );

        setUsers(paginatedUsers);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  const totalUsers = users.length;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div className="flex flex-col mx-4 p-4 bg-white rounded-lg h-4/5">    
      <div>
        <TableContainer component={Paper} className="hidden lg:flex">
          <Table className="min-w-full" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                users.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          const url = `/emailSignaturePanel?userId=${user?.uid}`;
                          window.open(url, "_blank"); // Open in a new tab
                        }}
                      >
                        Preview
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Grid View for Mobile */}
        <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          {loading ? (
            <div className="col-span-2 flex justify-center">
              <CircularProgress />
            </div>
          ) : (
            users.map((user, index) => (
              <Card key={user.id} className="shadow-lg">
                <CardContent className="text-center">
                  <h3 className="font-semibold text-lg">{user.name}</h3>
                  <p className="text-sm text-gray-500">{user.email}</p>
                  <div className="mt-2 flex justify-center">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {
                        const url = `/emailSignaturePanel?userId=${user?.uid}`;
                        window.open(url, "_blank");
                      }}
                    >
                      Preview
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
      <CustomPagination
        currentPage={page}
        totalItems={totalUsers}
        itemsPerPage={usersPerPage}
        onPageChange={(page) => setPage(page)}
      />     
    </div>
  );
};

export default Users;
